/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ grade: NonNullable<unknown> }} Directory_Detail_Score_Anatomy_GradeInputs */

const en_directory_detail_score_anatomy_grade = /** @type {(inputs: Directory_Detail_Score_Anatomy_GradeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editorial grade ${i?.grade}`)
};

const zh_directory_detail_score_anatomy_grade = /** @type {(inputs: Directory_Detail_Score_Anatomy_GradeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`编辑评级 ${i?.grade}`)
};

/**
* | output |
* | --- |
* | "Editorial grade {grade}" |
*
* @param {Directory_Detail_Score_Anatomy_GradeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_score_anatomy_grade = /** @type {((inputs: Directory_Detail_Score_Anatomy_GradeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Score_Anatomy_GradeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_score_anatomy_grade(inputs)
	return zh_directory_detail_score_anatomy_grade(inputs)
});
export { directory_detail_score_anatomy_grade as "directory.detail.score_anatomy_grade" }